export { FloatingBox } from './FloatingBox';
